export default __webpack_public_path__ + "static/bg-body-mobile-038665990d8b4a8a326ad1013f7fa2fc.jpg";